import { render, staticRenderFns } from "./CheckoutNotification.vue?vue&type=template&id=35610dd4&scoped=true"
import script from "./CheckoutNotification.vue?vue&type=script&lang=js"
export * from "./CheckoutNotification.vue?vue&type=script&lang=js"
import style0 from "./CheckoutNotification.vue?vue&type=style&index=0&id=35610dd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35610dd4",
  null
  
)

export default component.exports